import { atom } from 'jotai';
import { createInfluencerAtom } from '../influencer';
import { variablesAtom } from '../config';

export const variableMapAtom = atom((get) => ({
	'influencer.name':
		get(createInfluencerAtom).data?.name ||
		get(createInfluencerAtom).data?.email ||
		'Guest',
	'product.name': get(variablesAtom)?.productName,
	'product.url': get(variablesAtom)?.productURL,
	promocode: get(variablesAtom)?.promocode,
	'meta.platform': get(variablesAtom)?.metaPlatform,
	'meta.channel': get(variablesAtom)?.metaChannel,
	'meta.query': get(variablesAtom)?.metaQuery,
	// variables that override internal fields such as utm params
	'alt.source': get(variablesAtom)?.altSource,
	'alt.medium': get(variablesAtom)?.altMedium,
	'alt.campaign': get(variablesAtom)?.altCampaign,
	'alt.content': get(variablesAtom)?.altContent,
	'alt.term': get(variablesAtom)?.altTerm,
	// custom variables
	...get(customVariableMapAtom),
}));

// prefixes everything with 'custom' to be replaced
export const customVariableMapAtom = atom((get) => {
	const { custom } = get(variablesAtom) || {};
	if (!custom) return {};

	return Object.keys(custom).reduce(
		(acc, key) => ({
			...acc,
			[`custom.${key}`]: custom[key],
		}),
		{}
	);
});
